import {Transition} from '@headlessui/react';
import {flexRender, Row} from '@tanstack/react-table';
import cn from 'classnames';
import React, {forwardRef} from 'react';

export const ITEM_HEIGHT = 64;

export interface TableRowProps {
	row?: Row<any>;
	onClick?: (e: React.MouseEvent) => void;
}

export const TableBodyRow = forwardRef<HTMLTableRowElement, TableRowProps>(function TableBodyRow({row, onClick}, ref) {
	return (
		<Transition
			as={'tr'}
			show={true}
			className={'group h-16 hover:bg-black/[.04] cursor-pointer'}
			enter={'transition-opacity duration-100'}
			enterFrom={'opacity-80'}
			enterTo={'opacity-100'}
			onClick={onClick}
			ref={ref}
			appear
		>
			{row?.getVisibleCells().map((cell, ix) => (
				<td
					key={cell.id}
					className={cn('px-2', {
						'px-4': ix === 0 || ix === row?.getVisibleCells().length - 1,
					})}
				>
					{flexRender(cell.column.columnDef.cell, cell.getContext())}
				</td>
			))}
		</Transition>
	);
});
